module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("NOTE ON TRANSLITERATION")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Moroccan dialectical Arabic ("), _c('i', [_vm._v("darija")]), _vm._v(") varies from region to region and does not have a standardized written form, unlike Modern Standard Arabic. For words from Modern Standard Arabic, I have relied on the "), _c('i', [_vm._v("International Journal for Middle East Studies")]), _vm._v(". For darija, I refer to Heath 1987 and Harrell 1962 for transliteration. Where there are standard spellings for words that occur in English texts, such as "), _c('i', [_vm._v("tagine")]), _vm._v(" or "), _c('i', [_vm._v("Alaoui")]), _vm._v(", I use the Anglicized versions. I have followed those guidelines. Diacritics that do not occur in English have been simplified to make them accessible to readers.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffea4dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Fm02.vue
// module id = 75
// module chunks = 0